import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ProformaInvoicePDF from './ProformaInvoicePDF';
import Swal from "sweetalert2";

const ProformaInvoiceDetails = () => {
    const { id } = useParams(); // Get proformainvoice ID from URL
    const [proformainvoice, setProformaInvoice] = useState(null); // State to hold the proformainvoice data
    const navigate = useNavigate();
    const [proformainvoiceTerms, setProformaInvoiceTerms] = useState("");
    const [companyDetails, setCompanyDetails] = useState(null);
    const [taxInvoiceGenerated, setTaxInvoiceGenerated] = useState(false);
    const [errors, setErrors] = useState({});
    const [currency, setCurrency] = useState("");
    const [proformainvoiceNotes, setProformaInvoiceNotes] = useState("");
    const [bankAccounts, setBankAccounts] = useState([]);
    const fetchCompanyDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/settings`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setCompanyDetails(response.data.setting);
        } catch (error) {
            console.error("Error fetching company details:", error);
        }
    };
    const fetchBankAccounts = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/bank-accounts?type=bank account`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                }
            });

            // setBankAccounts(response.data.account || []);
            const firstTwoAccounts = (response.data.account || []).slice(0, 2);
            setBankAccounts(firstTwoAccounts);
        } catch (error) {
            console.error("Error fetching bank accounts:", error);
            setBankAccounts([]);
        }
    };

    // Fetch proformainvoice data from API
    const fetchProformaInvoiceById = async (proformainvoiceId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL; // Backend base URL
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            // Retrieve user info from localStorage
            const token = userInfo?.token; // Extract token

            const response = await axios.get(
                `${backendUrl}/api/proformainvoice/${proformainvoiceId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                }
            );
            console.log("API Response:", response.data);

            setProformaInvoice(response.data.proformainvoice);
            setTaxInvoiceGenerated(response.data.proformainvoice.tax_invoice_generated);
            setCurrency(response.data.proformainvoice.quotation?.currency);
            console.log('cuu:', currency);
        } catch (error) {
            console.error(`Error fetching proformainvoice with ID ${proformainvoiceId}:`, error);
            return null; // Return null if error occurs
        }
    };
    const handleGenerateTaxInvoice = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Send the request with the generate_tax_invoice flag
            const response = await axios.put(`${backendUrl}/api/proformainvoice/${id}`, {
                generate_tax_invoice: true, // Flag to trigger tax invoice generation
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            if (response.data.proforma_invoice) {
                console.log("Updated Proforma Invoice:", response.data.proforma_invoice);
                const updatedInvoice = response.data.proforma_invoice;

                setProformaInvoice(updatedInvoice);
                setTaxInvoiceGenerated(true);
                // if (updatedInvoice.tax_invoice_generated === true) {
                //     await createVATJournalEntry(updatedInvoice);
                // }

                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Tax Invoice Generated Successfully!',
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        // Adjust the container's position if needed
                        const container = Swal.getContainer();
                        container.style.top = '50px'; // Change this value as desired
                    }
                });
            } else {
                console.error("Failed to update proforma invoice.");
            }
        } catch (error) {
            console.error("Error generating tax invoice:", error);
        }
    };

    const fetchPITerms = async (currency) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));

            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotationterm`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const term = response.data.quotation_terms.data.find(term => term.type === "proforma_invoice");
            // const formattedTerms = term ? term.value.replace(/{{currency}}/g, currency || "USD") : "";
            let formattedTerms = "";

            if (term) {
                // Choose the appropriate content based on client currency
                if (currency === 'AED') {
                    formattedTerms = term.value_local || term.value || "";
                    console.log('📝 Using UAE Local Client Terms (AED) for Proforma Invoice');
                } else if (currency === 'USD') {
                    formattedTerms = term.value_export || term.value || "";
                    console.log('📝 Using Export Client Terms (USD) for Proforma Invoice');
                } else {
                    // Fallback to default value if currency is neither AED nor USD
                    formattedTerms = term.value || "";
                    console.log('📝 Using Default Terms for Proforma Invoice');
                }

                // Replace currency placeholder if needed
                formattedTerms = formattedTerms.replace(/{{currency}}/g, currency || "USD");
            }
            setProformaInvoiceTerms(formattedTerms);
            setProformaInvoiceNotes(formattedTerms);

        } catch (error) {
            console.error("Error fetching quotation terms:", error);
        }
    };
    useEffect(() => {
        const loadProformaInvoice = async () => {
            const fetchedProformaInvoice = await fetchProformaInvoiceById(id);
            if (fetchedProformaInvoice) {
                setProformaInvoice(fetchedProformaInvoice);
                // setProformaInvoiceNotes(fetchedProformaInvoice.notes);
                // await fetchPITerms(fetchedProformaInvoice.quotation?.currency);
            }
        };
        fetchCompanyDetails();
        loadProformaInvoice();
        fetchBankAccounts();
    }, [id]);
    useEffect(() => {
        if (currency) {
            fetchPITerms(currency);
        }
    }, [currency]);

    const handleBackClick = () => {
        // navigate(-1);
        window.history.back();

    };
    // Show loading message while fetching data
    if (!proformainvoice) return <div>Loading...</div>;
    const hasDiscount = proformainvoice.discount_amount && proformainvoice.discount_amount > 0;
    const TotalAmount = proformainvoice.amount - proformainvoice.deduction_amount;
    const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration'; // Adjust as needed
    const backendUrl = `${API}/api`; // Use this if you want to use
    // const backendUrl = 'http://localhost/webzash/api'; // adjust if needed
    const apiKey = process.env.REACT_APP_API_KEY; // replace with actual key

    const headers = {
        'x-api-key': apiKey,
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    const ensureGroupExists = async (groupName, parentGroupName, cachedGroups = null) => {
        if (!groupName || !parentGroupName) {
            throw new Error("Both groupName and parentGroupName are required");
        }

        const groups = cachedGroups || (await axios.get(`${backendUrl}/groups/index`, { headers })).data;

        const group = groups.find(g => g.Group.name === groupName);
        if (group) return group.Group.id;

        const parentGroup = groups.find(g => g.Group.name === parentGroupName);
        if (!parentGroup) throw new Error(`Parent group "${parentGroupName}" not found`);

        const payload = {
            Group: {
                name: groupName,
                parent_id: parentGroup.Group.id,
                code: null,
                affects_gross: 0,
            },
        };

        const { data: created } = await axios.post(`${backendUrl}/groups/add`, payload, { headers });
        return created.id;
    };


    const ensureLedgerExists = async (ledgerName, groupId, type = 0, credit = false, cachedLedgers = null) => {
        const ledgers = cachedLedgers || (await axios.get(`${backendUrl}/ledgers/index`, { headers })).data.data;

        const existing = ledgers.find(l => l.Ledger?.name === ledgerName);
        if (existing) return existing.Ledger.id;

        const payload = {
            Ledger: {
                name: ledgerName,
                code: null,
                group_id: groupId,
                op_balance: 0,
                op_balance_dc: credit ? "C" : "D",
                notes: "",
                type: type,
            }
        };

        const { data: created } = await axios.post(`${backendUrl}/ledgers/add`, payload, { headers });
        return created?.data?.Ledger?.id || created.Ledger?.id;
    };
    const createVATJournalEntry = async (proformaInvoice) => {
        const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration'; // Adjust as needed
        const backendUrl = `${API}/api`; // Use this if you want to use dynamic API URL
        // const backendUrl = 'http://localhost/webzash/api'; // Static Webzash API URL
        const apiKey = process.env.REACT_APP_API_KEY;

        const headers = {
            'x-api-key': apiKey,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        };

        // const amount = parseFloat(proformaInvoice.amount || 0);
        // const vatAmount = parseFloat(proformaInvoice.vat_amount || (amount * 0.05));
        // const roundedVAT = parseFloat((Math.round(vatAmount * 100) / 100).toFixed(2));
        const currency = proformaInvoice.quotation?.project?.client?.currency || 'AED';
        const isAed = currency === 'AED';
        const isTaxInvoice = proformaInvoice.tax_invoice_generated === true;

        const amount = parseFloat(proformaInvoice.amount || 0);
        const vatAmount = (isAed && isTaxInvoice)
            ? parseFloat(proformaInvoice.vat_amount || (amount * 0.05))
            : 0;

        const roundedVAT = parseFloat((Math.round(vatAmount * 100) / 100).toFixed(2));

        // ✅ Final Condition to skip
        if (!isAed || !isTaxInvoice || roundedVAT === 0) {
            console.warn("⛔ Skipping VAT journal entry: Not AED, tax invoice not generated, or VAT is zero.");
            return;
        }


        const clientName = proformaInvoice.quotation?.project?.client?.name || 'Unknown Client';
        const invoiceRef = proformaInvoice.ref_no;
        const date = new Date().toISOString().split('T')[0];

        // 🔁 Fetch groups & ledgers
        const allGroups = (await axios.get(`${backendUrl}/groups/index`, { headers })).data;
        const allLedgers = (await axios.get(`${backendUrl}/ledgers/index`, { headers })).data.data;

        const clientLedgerId = await ensureLedgerExists(clientName, await ensureGroupExists("Accounts Receivable", "Assets", allGroups), 0, false, allLedgers);
        const vatLedgerId = await ensureLedgerExists("Output VAT", await ensureGroupExists("Duties and Taxes", "Liabilities and Owners Equity", allGroups), 0, true, allLedgers);

        // ✅ Build journal entry
        const entryItems = [
            {
                dc: "D",
                ledger_id: clientLedgerId,
                dr_amount: roundedVAT.toFixed(2),
                cr_amount: "0.00",
            },
            {
                dc: "C",
                ledger_id: vatLedgerId,
                dr_amount: "0.00",
                cr_amount: roundedVAT.toFixed(2),
            }
        ];

        const payload = {
            Entry: {
                tag_id: null,
                number: Date.now(),
                date,
                narration: `VAT Entry for Tax Invoice ${invoiceRef}`,
            },
            Entryitem: entryItems,
        };

        try {
            const { data: result } = await axios.post(`${backendUrl}/entries/add/journal`, payload, { headers });
            console.log("✅ VAT journal entry created in Webzash:", result);
            if (result && result.entry_id) {
                const backendUrl1 = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem("user-info"));

                const origin = localStorage.getItem('user-origin');

                const token = userInfo?.token;
                await axios.put(`${backendUrl1}/api/taxinvoices/${proformaInvoice.tax_invoice?.id}`, {
                    journal_id: result.entry_id
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });

                console.log("💾 Journal ID saved to TaxInvoice table:", result.entry_id);
            }
        } catch (error) {
            const msg = error?.response?.data?.message || error.message || "Unknown error";
            console.error("❌ VAT journal entry failed:", msg);
        }
    };

    const renderBankAccounts = () => {
        if (!bankAccounts || bankAccounts.length === 0) {
            return null;
        }

        // ✅ For only one bank account
        if (bankAccounts.length === 1) {
            const account = bankAccounts[0];
            return (
                <div style={styles.bankAccountSection}>
                    <div style={styles.bankAccountHeader}>
                        <h4 style={styles.bankAccountTitle}>Bank Account Details</h4>
                    </div>

                    <div style={styles.singleBankAccount}>
                        <div style={styles.bankDetailsRow}>
                            <span style={styles.label}>Account Name:</span>
                            <span style={styles.value}>{account.account_holder_name || "N/A"}</span>
                        </div>
                        <div style={styles.bankDetailsRow}>
                            <span style={styles.label}>Bank Name:</span>
                            <span style={styles.value}>{account.name || "N/A"}</span>
                        </div>
                        <div style={styles.bankDetailsRow}>
                            <span style={styles.label}>Account Number:</span>
                            <span style={styles.value}>{account.account_number || "N/A"}</span>
                        </div>
                        <div style={styles.bankDetailsRow}>
                            <span style={styles.label}>IBAN:</span>
                            <span style={styles.value}>{account.iban || "N/A"}</span>
                        </div>
                        {account.swift_code && (
                            <div style={styles.bankDetailsRow}>
                                <span style={styles.label}>SWIFT Code:</span>
                                <span style={styles.value}>{account.swift_code}</span>
                            </div>
                        )}
                        {account.branch && (
                            <div style={styles.bankDetailsRow}>
                                <span style={styles.label}>Branch:</span>
                                <span style={styles.value}>{account.branch}</span>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        // ✅ For multiple bank accounts
        return (
            <div style={styles.bankAccountSection}>
                <div style={styles.bankAccountHeader}>
                    <h4 style={styles.bankAccountTitle}>Bank Account Details</h4>
                </div>

                <div style={styles.twoColumnBankAccounts}>
                    {bankAccounts.map((account, index) => (
                        <div key={index} style={styles.bankAccountCard}>
                            <div style={styles.bankDetailsRow}>
                                <span style={styles.label}>Account Name:</span>
                                <span style={styles.value}>{account.account_holder_name || "N/A"}</span>
                            </div>
                            <div style={styles.bankDetailsRow}>
                                <span style={styles.label}>Bank Name:</span>
                                <span style={styles.value}>{account.name || "N/A"}</span>
                            </div>
                            <div style={styles.bankDetailsRow}>
                                <span style={styles.label}>Account Number:</span>
                                <span style={styles.value}>{account.account_number || "N/A"}</span>
                            </div>
                            <div style={styles.bankDetailsRow}>
                                <span style={styles.label}>IBAN:</span>
                                <span style={styles.value}>{account.iban || "N/A"}</span>
                            </div>
                            {account.swift_code && (
                                <div style={styles.bankDetailsRow}>
                                    <span style={styles.label}>SWIFT Code:</span>
                                    <span style={styles.value}>{account.swift_code}</span>
                                </div>
                            )}
                            {account.branch && (
                                <div style={styles.bankDetailsRow}>
                                    <span style={styles.label}>Branch:</span>
                                    <span style={styles.value}>{account.branch}</span>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Proforma Invoice Details</h4>
                                <div className="page-title-right">

                                    <div className="page-title-right d-flex align-items-center">
                                        {proformainvoice.tax_invoice_generated ? (

                                            <button
                                                onClick={() => navigate(`/tax-invoice/details/${id}`, { state: { proformainvoice, companyDetails, currency } })}
                                                style={{
                                                    padding: "6px 16px",
                                                    backgroundColor: "#415094",
                                                    color: "#fff",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    whiteSpace: "nowrap", // Prevents text from wrapping to the next line
                                                    display: "inline-block", // Ensures the button doesn't stretch
                                                }}

                                            >
                                                Tax Invoice
                                            </button>
                                        ) : (
                                            <button
                                                onClick={handleGenerateTaxInvoice}
                                                style={{
                                                    padding: "6px 16px",
                                                    backgroundColor: "#415094",
                                                    color: "#fff",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    whiteSpace: "nowrap", // Prevents text from wrapping to the next line
                                                    display: "inline-block", // Ensures the button doesn't stretch
                                                }}
                                                className="btn btn-warning"

                                            >
                                                Genearte Tax Invoice
                                            </button>
                                        )}&nbsp;&nbsp;
                                        {/* <PDFDownloadLink
                                            document={<ProformaInvoicePDF proformainvoice={proformainvoice} proformainvoiceNotes={proformainvoiceNotes} proformainvoiceTerms={proformainvoiceTerms} companyDetails={companyDetails} />}
                                            fileName={`${proformainvoice.ref_no}.pdf`}
                                        >
                                            {({ loading }) => (
                                                <button
                                                    style={{
                                                        padding: "6px 16px",
                                                        backgroundColor: "#415094",
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "6px",
                                                        cursor: "pointer",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {loading ? " " : "Download"}
                                                </button>
                                            )}
                                        </PDFDownloadLink> */}
                                        <button
                                            style={{
                                                padding: "6px 16px",
                                                backgroundColor: "#415094",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "6px",
                                                cursor: "pointer",
                                                fontSize: "14px",
                                            }}
                                            onClick={() => {
                                                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                                                const userInfo = JSON.parse(localStorage.getItem("user-info"));
                                                const origin = localStorage.getItem("user-origin");
                                                const token = userInfo?.token;

                                                // Create download link
                                                const downloadUrl = `${backendUrl}/api/proformainvoice/${id}/download`;

                                                // Create temporary anchor element for download
                                                const link = document.createElement('a');
                                                link.href = downloadUrl;
                                                link.setAttribute('download', `${proformainvoice.ref_no}.pdf`);
                                                document.body.appendChild(link);

                                                // Add authorization headers through fetch
                                                fetch(downloadUrl, {
                                                    headers: {
                                                        'Authorization': `Bearer ${token}`,
                                                        'Tenant-Origin': origin,
                                                    }
                                                })
                                                    .then(response => response.blob())
                                                    .then(blob => {
                                                        const url = window.URL.createObjectURL(blob);
                                                        link.href = url;
                                                        link.click();
                                                        window.URL.revokeObjectURL(url);
                                                        document.body.removeChild(link);
                                                    })
                                                    .catch(error => console.error('Download failed:', error));
                                            }}
                                        >
                                            Download
                                        </button>

                                        &nbsp;&nbsp;
                                        {/* <div className="button-container"> */}

                                        <button style={{
                                            padding: "6px 16px",
                                            backgroundColor: "#415094",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                        }}
                                            onClick={handleBackClick} className="btn btn-secondary  back">Back</button>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div> </div>


                    {/* A4 ProformaInvoice Layout */}
                    <div style={styles.page}>
                        {/* Header Section */}
                        <div style={styles.header}>
                            <div>
                                <h2 style={styles.companyName}>{companyDetails?.company_name || 'Systech Technologies'}</h2>
                                <p style={styles.companyDetails}>
                                    {companyDetails?.phone} <br />
                                    {companyDetails?.email}<br />
                                    <p dangerouslySetInnerHTML={{ __html: companyDetails?.company_address }} />
                                </p>
                            </div>
                            <div style={styles.topRight}>
                                <img
                                    src="/images/655c8bbb23be8.png" // Provide the image source
                                    alt="Company Logo"
                                    style={styles.image}
                                />



                                <div style={styles.proformainvoiceTitle}>Proforma Invoice</div>
                            </div>
                        </div><hr style={styles.hr} />

                        {/* ProformaInvoice Details */}
                        <div style={styles.detailsSection}>
                            <div>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "90px" }}>Project:</strong>
                                    <span>{proformainvoice.quotation?.project?.name || " "}</span>
                                </p>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "90px" }}>Document No:</strong>
                                    <span>{proformainvoice.ref_no || ""}</span>
                                </p>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "90px" }}>Date:</strong>
                                    <span>
                                        {proformainvoice.created_at
                                            ? new Date(proformainvoice.created_at).toLocaleDateString().replace(/\//g, '-')
                                            : ""}
                                    </span>
                                </p>

                            </div>
                            <div>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "65px" }}>Customer:&nbsp;</strong>{proformainvoice.quotation?.project?.client?.name || " "}
                                </p>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "65px" }}>Address:&nbsp;</strong>{proformainvoice.quotation?.project?.client?.address || " "}
                                </p>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "90px" }}>Contact Phone:</strong>{proformainvoice.quotation?.project?.client?.contacts[0]?.phone || ""}
                                </p>
                                <p style={{ display: "flex", marginBottom: "10px" }}>
                                    <strong style={{ width: "90px" }}>Contact Email:</strong> {proformainvoice.quotation?.project?.client?.contacts[0]?.email || ""}
                                </p>
                            </div>
                        </div><br /><br />

                        {/* Table Section */}
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.tableHeader}>No</th>
                                    <th style={styles.tableHeader}>Product</th>
                                    <th style={styles.tableHeader}>Description</th>
                                    <th style={styles.tableHeader}>Qty</th>

                                    <th style={styles.tableHeader}>Rate</th>
                                    <th style={styles.tableHeader}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {proformainvoice?.quotation?.product_item_details && Array.isArray(proformainvoice.quotation.product_item_details) && proformainvoice.quotation.product_item_details.length > 0 ? (
                                    proformainvoice.quotation.product_item_details.map((item, index) => (
                                        <tr key={index}>
                                            <td style={styles.tableCell}>{index + 1}</td>
                                            <td style={styles.tableCell}>
                                                {item.product ? item.product.product_name : ""} {/* Display product name */}
                                            </td>
                                            <td style={styles.tableCell}>
                                                {item.item_description || ""} {/* Display description */}
                                            </td>

                                            <td style={styles.tableCell}>
                                                {item.quantity || ""} {/* Display quantity */}
                                            </td>
                                            <td style={styles.tableCell}>
                                                {item.price || ""} {/* Display price */}
                                            </td>
                                            <td style={styles.tableCell}>
                                                {item.subtotal || ""} {/* Display subtotal */}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="6"
                                            style={{
                                                textAlign: "center",
                                                padding: "10px",
                                                fontStyle: "italic",
                                            }}
                                        >
                                            No items available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* Footer Section */}
                        {/* <div style={styles.footer}>
                           
                           
                            <p>
                                <strong>{proformainvoice.advanced_amount}% Invoiced Amount: </strong> {proformainvoice.basic_amount|| "N/A"}
                            </p>
                            <p>
                                <strong>Total VAT:</strong> {Number(proformainvoice?.vat || 0)}
                            </p>
 {hasDiscount && (
                                <div>
                                    <p>
                                        <strong>One Time Discount{proformainvoice.quotation?.discount_type === 'percentage' ? ' (%)' : ''}:</strong>&nbsp; {proformainvoice.discount_amount || "N/A"}
                                    </p>
                                </div>
                            )}
                            <p>
                                <strong>Total({proformainvoice.quotation?.currency}):</strong> {proformainvoice.total_with_vat - proformainvoice.discount_amount|| ""}
                            </p><br /><br /> */}
                        {/* <div style={styles.terms}>
                                {proformainvoice.quotation?.notes && (
                                    <div>
                                        <div dangerouslySetInnerHTML={{ __html: proformainvoice.quotation?.notes }} />
                                    </div>
                                )}
                            </div> */}
                        <div style={{ ...styles.footer, fontSize: "12px", lineHeight: "1.6" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ textAlign: "right", paddingLeft: "150px" }}>
                                            <strong>{proformainvoice.advanced_amount}% Invoiced Amount:</strong>
                                        </td>
                                        <td style={{ textAlign: "right", whiteSpace: "nowrap", paddingRight: "10px" }}>
                                            {proformainvoice.basic_amount || ""}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ paddingLeft: "100px" }}>
                                            <strong>Total VAT:</strong>
                                        </td>
                                        <td style={{ textAlign: "right", whiteSpace: "nowrap", paddingRight: "10px" }}>
                                            {Number(proformainvoice?.vat || 0)}
                                        </td>
                                    </tr>

                                    {hasDiscount && (
                                        <tr>
                                            <td style={{ paddingLeft: "10px" }}>
                                                <strong>
                                                    One Time Discount
                                                    {proformainvoice.quotation?.discount_type === "percentage"
                                                        ? " (%)"
                                                        : ""}
                                                    :
                                                </strong>
                                            </td>
                                            <td style={{ textAlign: "right", whiteSpace: "nowrap", paddingRight: "10px" }}>
                                                {Number(proformainvoice.discount_amount || 0).toFixed(2)}
                                            </td>
                                        </tr>
                                    )}

                                    <tr>
                                        <td style={{ paddingLeft: "10px" }}>
                                            <strong>
                                                Total ({proformainvoice.quotation?.currency || "AED"}):
                                            </strong>
                                        </td>
                                        <td style={{ textAlign: "right", whiteSpace: "nowrap", paddingRight: "10px" }}>
                                            {(
                                                Number(proformainvoice.total_with_vat || 0) -
                                                Number(proformainvoice.discount_amount || 0)
                                            ).toFixed(2)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>




                            <div style={styles.terms}>

                                {proformainvoiceTerms && (
                                    <div dangerouslySetInnerHTML={{ __html: proformainvoiceTerms }} />


                                )}</div>

                            {renderBankAccounts()}

                        </div>
                        <div style={styles.signfooter}>
                            <div style={styles.signatureSection}>
                                {["Stamp", "Authorized"].map((role, index) => (
                                    <div key={index} style={styles.signatureBlock}>
                                        <p>--------------------------</p> {/* Placeholder line */}
                                        <p style={{ marginBottom: 0, lineHeight: "14px" }}>{role}</p>
                                        <p>{role === "Stamp" ? "" : "Signature"}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        </div >
    );
};


export default ProformaInvoiceDetails;

// Inline Styles for A4 Layout
const styles = {
    page: {
        width: "210mm",
        minHeight: "200mm",
        margin: "0 auto",
        padding: "10mm",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#ffffff",
        border: "1px solid #ddd",
        fontSize: "12px",
        borderRadius: "12px"
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        // marginBottom: "20px",
    },
    companyName: {
        fontSize: "18px",
        fontWeight: "bold",
        color: "#415094",
    },

    companyDetails: {
        fontSize: "14px",
        marginTop: "-7px",
        color: "#415094",

    },
    proformainvoiceTitle: {
        fontSize: "24px",
        color: "#415094",
        // marginBottom: "0px",

        marginLeft: "8px",
        lineHeight: ".4",
        // Add some margin between the image and the title
    },
    headerRight: {
        display: "flex",  // Make the container a flexbox to align the image and title side by side
        alignItems: "center", // Vertically align the content in the center
    },
    topRight: {
        alignSelf: "start",
        textAlign: "right",
    },
    Right: {
        alignSelf: "start",
        textAlign: "right",
        marginTop: "20px",
    },
    image: {

        objectFit: "contain",
        marginBottom: "20px",
        maxWidth: "214px",
        maxHeight: "100px",


    },
    hr: {
        marginTop: "-7px"
    },
    detailsSection: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "25px",
        marginTop: "10px",
        lineHeight: "1",
    },

    table: {
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: "20px",
        lineHeight: "3",

    },
    tableHeader: {
        borderBottom: "1px solid #ddd",
        padding: "8px",
        textAlign: "left",
        fontWeight: "bold",
    },
    tableCell: {
        borderBottom: "1px solid #ddd",
        padding: "8px",
        textAlign: "left",
    },
    footer: {
        marginTop: "30px",
        textAlign: "right",
    },
    terms: {
        fontSize: "12px",
        marginTop: "20px",
        textAlign: "left",
    },
    signfooter: {
        marginTop: "150px",
        textAlign: "center",

    },
    signatureSection: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        marginTop: "20px",
    },
    signatureBlock: {
        textAlign: "center",
    },
    signatureImage: {
        width: "120px",
        height: "50px",
        objectFit: "contain",
        marginBottom: "10px",
    },
    bankAccountSection: {
        marginTop: "30px",
        padding: "15px",
        border: "1px solid #ddd",
        borderRadius: "8px",
    },
    bankAccountHeader: {
        display: "flex",
        alignItems: "center",
        marginBottom: "15px",
    },
    bankAccountTitle: {
        fontSize: "16px",
        fontWeight: "bold",
        margin: 0,
    },
    singleBankAccount: {
        textAlign: "left",
    },
    twoColumnBankAccounts: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "20px",
        alignItems: "start",
    },
    bankAccountCard: {
        padding: "12px",
        border: "1px solid #e0e0e0",
        borderRadius: "6px",
        backgroundColor: "white",
        fontSize: "12px",
    },
    bankDetailsRow: {
        display: "flex",
        justifyContent: "flex-start",
        marginBottom: "4px",
    },
    label: {
        width: "130px", // ensures all values start from same vertical line
        fontWeight: "bold",
    },
    value: {
        // flex: 1,
        paddingLeft: "15px",
    },
};
